import { type ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import type { RhinoRead } from '@rhino-project/core';

// Active-season boards keep the player in the Season module, so the link needs
// the season's identifier and whether it is the active one.
type LinkTeamSeason = Pick<RhinoRead<'team_season'>, 'id'> &
  Partial<Pick<RhinoRead<'team_season'>, 'status'>>;

interface PlayerDetailLinkProps {
  owner: string;
  teamSeason: LinkTeamSeason;
  playerId: string;
  className?: string;
  children: ReactNode;
}

// Active-season boards keep the player in the Season module; planning/other boards
// link to the Plan-mode player page (which drives the nav back to Plan mode).
export const PlayerDetailLink = ({
  owner,
  teamSeason,
  playerId,
  className,
  children
}: PlayerDetailLinkProps) => {
  if (teamSeason.status === 'active') {
    return (
      <Link
        to="/$owner/active/$team_season_id/players/$id"
        params={{ owner, team_season_id: String(teamSeason.id), id: playerId }}
        className={className}
      >
        {children}
      </Link>
    );
  }
  return (
    <Link
      to="/$owner/players/$id"
      params={{ owner, id: playerId }}
      className={className}
    >
      {children}
    </Link>
  );
};
